import { useEffect, useState } from "react";
import { ProgramScheduleDTO } from "@campgladiator/cg-common.types.types";
import { UpgradeMembershipModalProps } from "../../";
import { SelectScheduleOptions, SelectScheduleProps } from "./SelectSchedule";

type SelectScheduleArgs = {
  onSelectedSchedule: (schedule: ProgramScheduleDTO) => void;
  programSchedules: SelectScheduleOptions[];
} & Pick<UpgradeMembershipModalProps, "productName" | "productPrice">;

const useWithSelectSchedule = ({
  programSchedules,
  productName,
  productPrice,
  onSelectedSchedule,
}: SelectScheduleArgs): SelectScheduleProps => {
  const [selectScheduleOptions, setSelectScheduleOptions] =
    useState<SelectScheduleOptions[]>(programSchedules);

  const toggleOption = (id: string, checked: boolean) => {
    const selectedOption = programSchedules.find((option) => option.id === id);
    onSelectedSchedule(selectedOption);
    return programSchedules.map((option) =>
      option.id === id ? { ...option, checked } : option
    );
  };

  const handleChange = (id: string, checked: boolean) => {
    const newCheckedList = toggleOption(id, checked);
    setSelectScheduleOptions(newCheckedList);
  };

  useEffect(() => {
    if (programSchedules) {
      setSelectScheduleOptions(programSchedules);
      const selectedOption = programSchedules.find((option) => option.checked);
      if (selectedOption) onSelectedSchedule(selectedOption);
    }
  }, [programSchedules]);

  return {
    productName,
    productPrice,
    selectScheduleOptions,
    handleChange,
  };
};

export { useWithSelectSchedule };
